// extracted by mini-css-extract-plugin
export var address = "contactInfo-module--address--urE1Y";
export var number = "contactInfo-module--number--BoPXV";
export var section = "contactInfo-module--section--d++Dp";
export var show = "contactInfo-module--show--z1jB1";